<template>
    <div class="tag-wrapper" v-click-outside="closeForm">
        <div class="tag">
      <span class="tag-head" @click="toggleForm">
        {{headerLabel}}: <span class="tagsList">{{selectedItemsName}}</span>
      </span>
            <span class="tag-close" @click="removeTag">
        <i class="close"></i>
      </span>
            <div class="tag-data" v-if="showTagData">
                <CCTagFilterSelect :options="options"
                                   :selectedOptions="selectedOptions"
                                   :optionId="optionId"
                                   :optionValue="optionValue"
                                   :optionAbbr="optionAbbr"
                                   :actionEvent="actionEvent"
                                   :removeEvent="removeEvent"
                                   :headerLabel="headerLabel"
                                   :twoColumns="twoColumns"></CCTagFilterSelect>
            </div>
        </div>
    </div>
</template>

<script>

    import CCTagFilterSelect from '@/components/common/CCTagFilterSelect';

    export default {
        name: "cc-filter-tag",
        components: {
            CCTagFilterSelect
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            selectedOptions: {
                type: Array,
                required: false
            },
            optionId: {
                type: String,
                required: true
            },
            optionValue: {
                type: String,
                required: true
            },
            optionAbbr: {
                type: String,
                required: false
            },
            headerLabel: {
                type: String,
                required: true
            },
            actionEvent: {
                type: Function,
                required: true
            },
            removeEvent: {
                type: Function,
                required: true
            },
            twoColumns: {
                type: Boolean,
                required: false
            }
        },
        data(){
            return {
                showTagData: false
            }
        },
        computed: {
            selectedItemsName: function(){

                let names = this.options.filter(item => this.selectedOptions.includes(item[this.optionId])).map(function(item){
                    return item[this.optionValue];
                }, this);

                names.sort(function(a,b){
                    let nameA = a.toLowerCase();
                    let nameB = b.toLowerCase();

                    if (nameA > nameB)
                    {
                        return 1;
                    }
                    else
                    {
                        return -1;
                    }

                    return 0;
                });

                let numElements = names.length;
                let fewFirstNames = names.slice(0, 2).join(', ');
                let result = null;

                if (names.length > 2)
                {
                    result = fewFirstNames + ', + ' + (numElements - 2) + ' more';
                }
                else
                {
                    result = fewFirstNames;
                }

                return result;
            }
        },
        methods: {
            toggleForm: function(){
                this.showTagData = !this.showTagData;
            },
            closeForm: function(){
                this.showTagData = false;
            },
            removeTag: function(){
                this.showTagData = false;
                this.removeEvent([]);
            },
            closeTagForm: function(){
                this.showTagData = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .tag-wrapper {
        text-align: left;
    }

    .tag {
        background-color: $tag-background;
        border: 1px solid $tag-background;
        border-radius: 2px;
        color: $tag-color;
        padding: 4px 10px 4px 10px;
        display: inline-block;
        float: left;
        margin: 1px 0.25rem 0 0.25rem;
        font-size: 14px;
    }

    .tagsList {
        cursor: pointer;
        font-weight: bold;
    }

    .tag-head {
        color: #fff;
    }

    .tag-data .tag-select-wrapper .tag-wrapper .sitesListFilter {
        color: #000;
        border: 0;
        padding: 0px 0px 5px 0px;
        float: none;
        margin: 0;
    }

    .tag-close {
        padding-left: 10px;

        & > i.close {
            display: inline-block;
            width: 0.7em;
            height: 0.7em;
            color: #fff;
            background-image: url('/static/img/icon-filter-close.svg');
            background-repeat: no-repeat;
            background-position: center;
            cursor: pointer;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/CCFilterTag.vue